/**
 * @file: WarningIcon.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const WarningIcon: FC<IconProps> = memo(
  ({ width, height, size, color, style }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 36 36"
        fill="none"
        style={style}
      >
        <G clipPath="url(#clip0_381_1624)">
          <Path
            d="M16.0714 26.3571C16.0714 26.8686 16.2746 27.3592 16.6363 27.7208C16.998 28.0825 17.4885 28.2857 18 28.2857C18.5115 28.2857 19.002 28.0825 19.3637 27.7208C19.7254 27.3592 19.9286 26.8686 19.9286 26.3571C19.9286 25.8457 19.7254 25.3551 19.3637 24.9934C19.002 24.6318 18.5115 24.4286 18 24.4286C17.4885 24.4286 16.998 24.6318 16.6363 24.9934C16.2746 25.3551 16.0714 25.8457 16.0714 26.3571ZM16.7143 14.1429V21.5357C16.7143 21.7125 16.8589 21.8571 17.0357 21.8571H18.9643C19.1411 21.8571 19.2857 21.7125 19.2857 21.5357V14.1429C19.2857 13.9661 19.1411 13.8214 18.9643 13.8214H17.0357C16.8589 13.8214 16.7143 13.9661 16.7143 14.1429ZM35.8272 31.8214L19.1129 2.89286C18.8638 2.46295 18.4339 2.25 18 2.25C17.5661 2.25 17.1321 2.46295 16.887 2.89286L0.172748 31.8214C-0.321448 32.6813 0.297302 33.75 1.28569 33.75H34.7143C35.7027 33.75 36.3214 32.6813 35.8272 31.8214ZM4.3473 30.7004L18 7.06741L31.6527 30.7004H4.3473Z"
            fill={color}
          />
        </G>
        <Defs>
          <ClipPath id="clip0_381_1624">
            <Rect width="36" height="36" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    );
  },
);
